import React from 'react';

export default class NotFound extends React.Component {

  // constructor(props) {
  //   super(props);
  //
  //   // this.state = {
  //   //   data : [],
  //   //   value: 'coconut',
  //   //   toDo: true,
  //   // };
  // }

  render() {
    return (

      <div><br/>The requested page was not found...</div>
    )
  }
}
